import { render, staticRenderFns } from "./ConsultationPage.vue?vue&type=template&id=3f895d37&scoped=true&"
import script from "./ConsultationPage.vue?vue&type=script&lang=js&"
export * from "./ConsultationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationPage.vue?vue&type=style&index=0&id=3f895d37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f895d37",
  null
  
)

export default component.exports